module.exports = __webpack_public_path__ + "img/nuova-istanza.340226ee.jpg";